import React from 'react';
import clsx from 'clsx';

import scss from './ToggleSwitch.module.scss';

function ToggleSwitch({ checked, label, onChange }) {
  return (
    <button
      type='button'
      role='switch'
      aria-checked={checked}
      aria-label={label}
      className={clsx(scss.switch, checked && scss.switchOn)}
      onClick={() => onChange(!checked)}>
      <span />
    </button>
  );
}

export default ToggleSwitch;
